import { useCallback, useState } from 'react';
import type { Menu } from '../types';

export const useAnalysisModal = () => {
  const [analysisModalVisible, setAnalysisModalVisible] = useState(false);
  const [currentMenuItem, setCurrentMenuItem] = useState<Menu | null>(null);

  const showAnalysisModal = useCallback((record: Menu) => {
    setCurrentMenuItem(record);
    setAnalysisModalVisible(true);
  }, []);

  const closeAnalysisModal = useCallback(() => {
    setAnalysisModalVisible(false);
    setCurrentMenuItem(null);
  }, []);

  return {
    analysisModalVisible,
    currentMenuItem,
    showAnalysisModal,
    closeAnalysisModal,
  };
};
